import {FormValues} from '@wix/form-viewer'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useState} from 'react'
import {useAppSelector} from '../../../../hooks/runtime'
import {getUseBuyerDetails} from '../../../../selectors/checkout'
import c from '../../../classnames.scss'
import {buildOverrides} from '../../../wix-form'
import {TicketDetailsForm} from '../ticket-details-form'
import {TicketDetailsHeader} from '../ticket-details-header'
import {TicketDetailsProps} from './interfaces'
import s from './ticket-details.scss'
import {useFocusHandler} from './use-focus-handler'

const INITIAL_FORM_VALUES: FormValues = {}

export const TicketDetails = ({
  individualTicket,
  editable,
  expanded,
  index,
  formId,
  lastTicket,
  onExpand,
  onRegisterFormHandle,
}: TicketDetailsProps) => {
  const [formValues, setFormValues] = useState<FormValues>(INITIAL_FORM_VALUES)
  const useBuyerDetails = useAppSelector(getUseBuyerDetails)
  const firstTicket = index === 0
  const overrides = buildOverrides({
    initialValues: INITIAL_FORM_VALUES,
    member: false,
    ticketed: true,
    useBuyerDetails: useBuyerDetails && firstTicket,
  })

  formValues.first_name

  useFocusHandler({expanded, index})

  return (
    <div className={classNames(c.formLabelsFont, c.formTitleColor)} data-hook={DH.TICKET_DETAILS_FORM(index)}>
      <TicketDetailsHeader
        individualTicket={individualTicket}
        formValues={formValues}
        expanded={expanded}
        ticketIndex={index}
        editable={editable}
        onExpand={onExpand}
      />
      {editable && (
        <TicketDetailsForm
          formId={formId}
          formIndex={index}
          expanded={expanded}
          formValues={formValues}
          lastTicket={lastTicket}
          overrides={overrides}
          onChange={setFormValues}
          onRegisterFormHandle={onRegisterFormHandle}
        />
      )}
      {(!lastTicket || editable) && <div className={classNames(s.divider, {[s.expanded]: expanded})} />}
    </div>
  )
}
